"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Toolbar", {
    enumerable: true,
    get: function() {
        return Toolbar;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useToolbar = require("./useToolbar");
const _renderToolbar = require("./renderToolbar");
const _useToolbarStylesstyles = require("./useToolbarStyles.styles");
const _useToolbarContextValues = require("./useToolbarContextValues");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const Toolbar = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useToolbar.useToolbar_unstable)(props, ref);
    const contextValues = (0, _useToolbarContextValues.useToolbarContextValues_unstable)(state);
    (0, _useToolbarStylesstyles.useToolbarStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useToolbarStyles_unstable')(state);
    return (0, _renderToolbar.renderToolbar_unstable)(state, contextValues);
});
Toolbar.displayName = 'Toolbar';
